import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["step"]

  connect() {
    this.configureButtons();
  }

  configureButtons() {
    const currentStepName = this.currentStepName;
    let finishedActivations = false;

    this.stepTargets.forEach((stepElement) => {
      const stepName = stepElement.dataset.step;
      const buttonElement = stepElement.querySelector('button');

      if (stepName === currentStepName) {
        finishedActivations = true;
        stepElement.classList.add('current');
        stepElement.classList.remove('active');
        buttonElement.disabled = false;
      } else if (finishedActivations) {
        stepElement.classList.remove('current');
        stepElement.classList.remove('active');
        buttonElement.disabled = true;
      } else {
        stepElement.classList.remove('current');
        stepElement.classList.add('active');
        buttonElement.disabled = false;
      }
    });
  }

  goToStep(event) {
    event.preventDefault();
    const path = event.currentTarget.dataset.path;
    if (path) {
      window.location.href = path;
    }
  }

  get currentStepName() {
    return this.element.dataset.stepperCurrentStep;
  }
}
